import { activationStrategy } from 'aurelia-router';
import { Toastr } from 'Code/Extension/Toastr';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { Config } from 'Config';

export class BaseView {
    
    // unique id property
    protected guid : string = null;
    protected apiUrl: string = null;
    protected instanceName: string = null;
    protected isOnline: boolean = true;

    // set activation strategy
    determineActivationStrategy() {
        return activationStrategy.replace;
    }

    // base contructor
    constructor() {
        this.apiUrl = Config.ApiUrl();
        this.guid = GuidHelper.NewGuid();
        this.instanceName = Config.InstanceName();
        this.isOnline = Config.IsOnline();
    }

    public ApiCrudShowToastrError(entityId: number, entityName: string, response: any){
        let passData = {
            'EntityName': entityName,
            'RecordId': entityId,
            'View': 'Edit',
            'ApiMethod': 'Save',
            'Status': 'Error',
            'Message': response['message'],
            'Exception': response['exception']
        };
        window.parent.postMessage(JSON.stringify(passData), "*");
        Toastr.Error(response['message'], response['exception'], false);
    }
}